module.exports = __webpack_public_path__ + "assets/img/btn-back-4f250e76.png";